define(
    'Code25.Reset', [
    'Backbone', 'Utils', 'underscore', 'Tools'
],
    function (
        Backbone, Utils, _, Tools
    ) {
        'use strict';

        return {
            mount: function (container) {

                var layout = container.getComponent('Layout');
                if (layout) {
                    if (SC.ENVIRONMENT.SCTouchpoint == "checkout") {

                        function getParameterByName(name, url = window.location.href) {
                            name = name.replace(/[\[\]]/g, '\\$&');
                            var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                                results = regex.exec(url);
                            if (!results) return null;
                            if (!results[2]) return '';
                            return decodeURIComponent(results[2].replace(/\+/g, ' '));
                        }


                        var LoginRegisterForgotPasswordView = require("LoginRegister.ForgotPassword.View");

                        if (LoginRegisterForgotPasswordView) {
                            _.extend(LoginRegisterForgotPasswordView.prototype, {
                                getContext: _.wrap(LoginRegisterForgotPasswordView.prototype.getContext, function (getContext, options) {
                                    var res = getContext.apply(this, _.rest(arguments));
                                    res.email = getParameterByName("email");
                                    if (res.email) {
                                        this.model.set("email", res.email);
                                    }


                                    return res;
                                })
                            });
                        }


                    }
                }

            }
        }
    }
);
